import React from "react";

const Introduction = () => {
  return <div>Introduction</div>;
};

export default Introduction;
